import React from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import routerFunction from 'client/route.js'

const container = document.querySelector('#container')
const root = createRoot(container)
const router = routerFunction()
root.render(<RouterProvider router={router} />)
// root.render(<Router history={browserHistory}>{routes}</Router>)
